export type Consent = {
  analytics: boolean;
  replay: boolean;
  ccpa_opt_out: boolean;
  ts: number;
};

const KEY = "smartly_consent_v1";
export const CONSENT_EVENT = "smartly:consentchange";

export function readConsent(): Consent | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Consent;
  } catch {
    return null;
  }
}

export function writeConsent(c: Omit<Consent, "ts">) {
  const value: Consent = { ...c, ts: Date.now() };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* noop */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
}

export function hasGlobalPrivacyControl(): boolean {
  const nav = navigator as Navigator & { globalPrivacyControl?: boolean };
  return nav.globalPrivacyControl === true;
}

export function effectiveConsent(): Consent {
  const stored = readConsent();
  const gpc = hasGlobalPrivacyControl();
  if (gpc) {
    return { analytics: false, replay: false, ccpa_opt_out: true, ts: stored?.ts ?? 0 };
  }
  return stored ?? { analytics: false, replay: false, ccpa_opt_out: false, ts: 0 };
}
